








/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectService } from '@store/service/ProjectService';
import { projectStateConfig } from '@config';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    created() {
        this.projectService = new ProjectService(this.$store);
    },

    methods: {
        click() {
            this.$store.dispatch('notification/setRead', this.notification.id).then(response => {
                const data = this.notification.data;

                this.projectService.getProject(data.id).then(response => {
                    const project = response.data;
                    const stateConfig = projectStateConfig[project.state];

                    let route = stateConfig.route;
                    route = route.replace('[projectId]', project.id);
                    
                    this.$router.push(route);
                });
            })
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Notification extends Vue {
    @Prop() notification!: string
};

